import React, { useContext } from 'react';
import styled from 'styled-components';
import { NotificationsContext } from '@/store/context/notifications';
import Button from './Button';


export default function Counter({
  value,
  maxValue = 10,
  minValue = 1,
  step = 1,
  onChange
}:{
  value: number;
  step?: number;
  maxValue?: number;
  minValue?: number;
  onChange(newValue: number): void;
}) {

  const { add } = useContext(NotificationsContext);
  
  const onPlusHandler = (e) => {
    if(value + step > maxValue) {
      add({
        title: `Этого наименования Вы можете забронировать до ${maxValue} упаковок`,
        button: <Button href="/cart" color="white">Перейти в корзину</Button>,
        color: 'attention'
      });
      return;
    }
    onChange(value + step);
    const currentCounter = e.target.closest('.currentCounter').querySelector('span');
    currentCounter.style.backgroundColor = 'var(--green)';
    currentCounter.style.color = 'white';
    setTimeout(() => {
      currentCounter.style.backgroundColor = 'initial';
      currentCounter.style.color = 'var(--color-title)';
    }, 200);
  }

  const onMinusHandler = (e) => {
    if(value - step < minValue) return;
    onChange(value - step);
    const currentCounter = e.target.closest('.currentCounter').querySelector('span');
    currentCounter.style.backgroundColor = 'var(--green)';
    currentCounter.style.color = 'white';
    setTimeout(() => {
      currentCounter.style.backgroundColor = 'initial';
      currentCounter.style.color = 'var(--color-title)';
    }, 200);
  }

  return <Container className='currentCounter'>
    <Button color="transparent" onClick={(e) => onMinusHandler(e)}>-</Button> 
    {value > maxValue ? <span className="red">{value}</span> : <span>{value}</span>}
    <Button color="transparent" onClick={(e) => onPlusHandler(e)}>+</Button>
  </Container>
}

const Container = styled.div`
  display: inline-block;
  white-space: nowrap;


  & span {
    padding: 4px 0 2px;
    margin: 0 4px;
    min-width: 22px;
    display: inline-block;
    text-align: center;
    border-radius: 5px;
  }

  & span.red {
    /* background-color: var(--red); */
    border: 1px solid var(--red);
    /* color: var(--white); */
    color: var(--red);
  }

  & a {
    font-size: 18px;
    height: 25px;
    width: 25px;
    min-width: initial;
    padding: 0;
  }
`